/*=========================================================================================
  File Name: module-config-actions.js
  Description: Config Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import ConfigAPI from '../../api/ConfigAPI';
import httpClient from '../../api/axios-httpclient';
import commonFunc from '@/common/commonFunction';

export default {
	getConfigInfo: async function(context, payload) {
		try {
			let res = await httpClient.getAsync({
				url: ConfigAPI.getAPIUrl() + '/info'
			});

			if (res.Success) {
				context.commit('updateConfig', res.Data);
			}
		} catch (ex) {
			commonFunc.errorLogging('Lỗi lấy thông tin config:: ', ex);
		}
	}
};
